<template>

  <div class="uk-grid-collapse" uk-grid>

    <div class="uk-width-1-1">
      <!-- radio Media -->
      <div class="ops-radio-media">
        <h3 class="uk-align-left uk-margin-remove-bottom">Média</h3>
        <ul class="uk-align-left ops-search-media-list">
          <li v-for="media in getMediaSelectList"
              :key="media"
              :class="{selected: isSelected(media)}"
              @click="emitUpdateMediaSelect(media)"><span></span>
            {{media}}
          </li>
        </ul>
      </div>
    </div>

    <!-- custom List -->
    <!-- uk-width-1-4 -->
    <div class="uk-width-1-4 uk-padding-remove uk-margin-remove-right criteres-list-wrap">

      <div class="uk-margin-remove uk-padding-small">
        <p class="uk-margin-small-bottom"><strong>Critères</strong></p>
        <div class="uk-search uk-search-default">
          <a href="#" uk-search-icon></a>
          <input class="uk-search-input" type="search" placeholder="Rechercher..." v-model="filterText">
        </div>
      </div>
      <nav class="uk-margin-remove uk-padding-small uk-navbar-container" uk-navbar>
        <div class="uk-navbar-left">
          <span class="all-critere-title">Ouvrir les critères</span>
        </div>
        <div class="uk-navbar-right">
          <ul class="uk-iconnav">
            <li v-if="!getCritereToggle"><a class="uk-margin-small-right" @click="emitToggleAllSousCritere(getCritereToggle)" uk-icon="icon: arrow-down" uk-tooltip="title: Ouvrir tous les sous critères; delay: 500"></a></li>
            <li v-if="getCritereToggle"><a class="uk-margin-small-right" @click="emitToggleAllSousCritere(getCritereToggle)" uk-icon="icon: arrow-up" uk-tooltip="title: Fermer tous les sous critères; delay: 500"></a></li>
          </ul>
        </div>
      </nav>

      <draggable
        class="dragArea list-group scrollable"
        :list=filterCriteres
        :group="{ name: 'critere', pull: 'clone', put: false}"
        :clone="addToForm"
        :sort=false
      >
         <div class="list-group-item" :class="returnLevel(critere.level)" v-for="critere in filterCriteres" :key="critere.chLibs">
           <div class="critere-item-wrapper" v-bind:class="{ close: !critere.show, 'uk-active': critere.children && critere.open }">
             <div class="critere-item">
               <a class="uk-link uk-light uk-visible@s">
                 <i class="uk-icon" uk-icon="icon: m_drag_indicator; ratio: 0.75"></i>
               </a>
               {{ critere.chLibs }}
               <i @click="emitToggleSousCritere(critere)"
                  v-if="critere.children && !critere.open"
                  uk-icon="icon: chevron-right; ratio: 1" class="uk-align-right">
               </i>
               <i @click="emitToggleSousCritere(critere)"
                  v-if="critere.children && critere.open"
                  uk-icon="icon: chevron-down ; ratio: 1" class="uk-align-right">
               </i>
             </div>
           </div>
         </div>
      </draggable>

    </div>

    <!-- Debug to remove Last PROD -->
    <template class="debug-zone" v-if="envVar == 'dev'">

      <div class="uk-width-1-3  uk-margin-remove-left uk-padding uk-padding-small-top form-list-wrap uk-background-muted">
        <p class="uk-margin-small"><strong>Requête</strong></p>
        <div v-if="getRequeteList.length <= 0" class="uk-placeholder uk-text-center">Déposer des éléments ici</div>
        <nested-drag-req @submit-form="submitFormInput" :children="getRequeteList"/>

        <div id="formInsidevue">
          <form ref="jsonForm"  action="?urlaction=docList" method="post">
            <input type="hidden" name="F_doc_form" value="2"/>
            <input type="hidden" name="json_query" id="json_query" v-model="jsonValue"/>
            <input type="hidden" name="reset_refine" value="1"/>
            <button class="uk-button uk-button-primary uk-align-right">Valider</button>
          </form>
        </div>

        <div class="uk-width-1-1 uk-margin-small-top">
          <button class="uk-button uk-button-default uk-button-small" @click="emitClearForm">Effacer les critères</button>
        </div>
        <div class="uk-width-1-1 uk-margin-small-top">
          <button class="uk-button uk-button-default uk-button-small" @click="emitInitForm">Réinitialiser le formulaire</button>
        </div>
      </div>

      <div class="uk-width-1-6">
        <pre>{{getRequeteList}}</pre>
      </div>

      <div class="uk-width-1-6">
        <pre>{{getSendRequete}}</pre>
      </div>

    </template>

    <!-- Real display PROD col : uk-width-5-6-->
    <template class="debug-zone" v-if="envVar != 'dev'">

      <div class="uk-width-3-4 uk-margin-remove-left uk-padding uk-padding-small-top form-list-wrap uk-background-muted">
        <p class="uk-margin-small"><strong>Requête</strong></p>
        <div v-if="getRequeteList.length <= 0" class="uk-placeholder uk-text-center">Deposer des éléments ici</div>
        <nested-drag-req @submit-form="submitFormInput" :children="getRequeteList"/>
        <div id="formInsidevue">
          <form ref="jsonForm"  :action="addBaseUrl('?urlaction=docList')" method="post">
            <input type="hidden" name="F_doc_form" value="2"/>
            <input type="hidden" name="tri" value="datdif0,heure0"/>
            <input type="hidden" name="json_query" id="json_query" v-model="jsonValue"/>
            <input type="hidden" name="reset_refine" value="1"/>
            <button onclick="SKOPUS.ACTIONS.createSpinnerOverlay()" class="uk-button uk-button-primary uk-align-right">Valider</button>
          </form>
        </div>

        <div class="uk-width-1-1 uk-margin-small-top">
          <button class="uk-button uk-button-default uk-button-small" @click="emitClearForm">Effacer les critères</button>
        </div>
        <div class="uk-width-1-1 uk-margin-small-top">
          <button class="uk-button uk-button-default uk-button-small" @click="emitInitForm">Réinitialiser le formulaire</button>
        </div>
      </div>

    </template>

  </div>

</template>

<script>
import { critereMixin } from '../mixin/critereMixin'
import { mapActions, mapGetters } from 'vuex'
import NestedDragReq from './form-elements/NestedDragReq'
import draggable from 'vuedraggable'

let idGlobal = 100000

export default {
  display: 'Nested',
  mixins: [critereMixin],
  components: {
    draggable,
    NestedDragReq
    // nestedJson
  },
  data () {
    return {
      mediaSelectArray: ['Tous'],
      jsoncritere: {},
      drag: false,
      baseApiUrl: process.env.VUE_APP_TAG_API,
      envVar: process.env.VUE_APP_ENV,
      iframesrc: 'palette.html'
    }
  },
  mounted () {
    this.$store.dispatch('emitInitCriteresList')
    this.$root.$on('submit-form', this.submitFormInput) // Écouteur global pour l'événement 'submit-form'
  },
  computed: {
    ...mapGetters([
      'getMediaSelectList',
      'getMediaSelectArrayActive',
      'getCritereToggle',
      'getRequeteList',
      'getSendRequete',
      'getBaseUrl'
    ]),
    jsonValue () {
      return JSON.stringify(this.getSendRequete)
    },
    dragOptions () {
      return {
        animation: 0,
        group: 'description',
        disabled: false,
        ghostClass: 'fromghost'
      }
    },
    valueString () {
      return JSON.stringify(this.list, null, 2)
    }
  },
  methods: {
    ...mapActions([
      'emitUpdateMediaSelect',
      'emitLoadCriteresList',
      'emitToggleSousCritere',
      'emitToggleAllSousCritere',
      'emitCleanRequeteNode',
      'emitClearForm',
      'emitInitForm'
    ]),
    submitFormInput () {
      this.$refs.jsonForm.submit()
    },
    isSelected (media) {
      return this.getMediaSelectArrayActive.includes(media)
    },
    addBaseUrl (url) {
      return this.getBaseUrl + url;
    },
    checkMove: function (evt) {
      // return (evt.draggedContext.element.name!=='apple');
      // console.log('evt')
    },
    addToForm ({ chLibs, chFields, chTypes, type, autocomplete, placeholder, index }) {
      // Create on Drag (before drop)
      return {
        id: String(idGlobal++),
        chOps: 'AND',
        chLibs: chLibs,
        chFields: chFields,
        chValues: '',
        chTypes: chTypes,
        type: type,
        placeholder: placeholder,
        autocomplete: autocomplete,
        index: index,
        children: []
      }
    },
    returnLevel (id) {
      return 'level_' + id
    },
    deleteFormCritere (element) {
      this.list.splice(this.list.findIndex(e => e.id === element.id), 1)
    },
    load () {
      // console.log('#AKIDEBUG : Iframe Loaded')
      // EventBus.$on('pallette-iframe', this.updatePannelIframe());
      EventBus.$on('pallette-iframe', function (payLoad) {
        // console.log('#AKIDEBUG : EventBus received In AdvancedSearch component')
        // console.log('#AKIDEBUG :', payLoad)
      })
    }
  },
  beforeDestroy () {
    // Nettoyer l'écouteur lorsque le composant est détruit
    this.$root.$off('submit-form', this.submitFormInput)
  }
}
</script>

<style lang="scss">
  @use "../../../../assets/css/init.scss" as init;

  /* Inter */
  @font-face {
    font-family: 'Inter';
    src: url('../assets/fonts/Inter/Inter-VariableFont_opsz,wght.ttf') format('truetype');
    font-weight: 100 900;
    font-style: normal;
  }

  /* Inter Italique */
  @font-face {
    font-family: 'Inter';
    src: url('../assets/fonts/Inter/Inter-Italic-VariableFont_opsz,wght.ttf') format('truetype');
    font-weight: 100 900;
    font-style: italic;
  }

  /* Material+Icons */
  @font-face {
    font-family: 'Material Icons';
    src: url('../assets/fonts/Material-Icons/MaterialIcons-Regular.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
  }

  body, p, h1, h2, h3, h4 {
    font-family: Inter;
  }

  #formInsidevue .uk-button.uk-button-primary{
    color: #FFFFFF;
    background-color: #3782AA;
    border-radius: 5px;
    padding: 0 30px;
    text-transform: none;
    font-size: .875rem;
    line-height: 38px;
    height: auto;
    margin-top: 20px;
  }

  .rotate-icon {
    transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    transition-property: transform;
    transition-duration: 5s;
  }

  .rotate-icon-180 {
    transform: rotate(180deg);
    -webkit-transform: rotate(180deg);
  }

  .ops-radio-media {

    //ops-search-media-list
    h3 {
      margin-top: 8px;
      margin-right: 15px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0.75rem;
      color: #626D7E;
    }

    ul.ops-search-media-list {
      padding: 0;

      li {
        list-style: none;
        display: inline-block;
        /*padding: 2px 10px 2px 25px;
        border-radius: 25px;
        text-decoration: none;
        color: $color-primary;
        background: transparent;
        transition: .4s;
        font-size: $size5;
        position: relative;
        transition: .4s;
        cursor: pointer;*/

        font-size: 0.75rem;
        background-color: #F6F6F6;
        color: #626D7E;
        border: 1px solid #F6F6F6;
        border-radius: 50px;
        padding: 4px 15px;
        cursor: pointer;
        user-select: none;
        margin-right: 10px !important;
      }

      li:hover {
        background-color: #EEF8FA;
        color: #4D7894;
        border-bottom-color: #B8DEE6;
      }

      li.selected {
        background-color: #CEEBF2;
        color: #3782AA;
        border-bottom-color: #B8DEE6;
      }

      li:hover span,
      li.selected span {
       /* height: 14px;
        width: 14px;
        border: 1px dashed #ffffff;
        border-radius: 100%;
        display: inline-block;
        position: absolute;
        left: 5px;
        top: 3px;*/
      }
    }

  }

  .uk-search-default {
    width: 100%;
    background-color:#8585851A;
    border-radius: 6px;
    .uk-search-icon{
      color: #3782AA;
    }
    .uk-search-input{
      border: none;
      &::placeholder {
        color:#626D7E; /* Change la couleur du placeholder */
        font-size: 12px;
      }
    }
  }

  .flip-list-move {
    transition: transform 0.5s;
  }

  .no-move {
    transition: transform 0s;
  }

  .ghost {
    opacity: 0;
  }

  .uk-placeholder{
/*    opacity: 0.5;
    background: #CEEBF2 !important;
    color: #3782AA !important;
    border: 2px dashed #3782AA;
    border-radius: 6px;*/
  }
  .fromghost {
    opacity: 0.5;
    background: #CEEBF2 !important;
    color: #CEEBF2 !important;
    border-radius: 6px;
    border: 1px dashed #3782AA;
    padding: 5px 15px;
    min-height: 50px;
  }

  .flip-list-move {
    transition: transform 0.5s;
  }

  .no-move {
    transition: transform 0s;
  }

  /* LEFT LIST */

  .criteres-list-wrap {
    border: 1px solid rgba(0, 0, 0, .125);

  }

  .criteres-list-wrap .list-group {
    padding: 0.5rem;
    height: 100%;
    max-height: 700px;
    overflow-y: scroll;
  }

  .criteres-list-wrap .uk-link {
    margin: 0;
  }

  .uk-padding-small-top {
    padding-top: 15px;
  }

    .all-critere-title{
      font-size: 12px;
      font-weight: 600;
    }
  .criteres-list-wrap .list-group-item .critere-item-wrapper {
    .critere-item {
      font-size: 12px;
      font-weight: 600;
      cursor: move;
      position: relative;
      display: block;
      padding: .5rem 1rem;
      margin: .3rem 0;
      background-color: #fff;
      /*border: 1px solid rgba(0, 0, 0, .125);*/
      border-radius: 60px;
    }
    &.uk-active .critere-item{
      background-color: #CEEBF2;
      color: #3782AA;
      border: none;
      .uk-link .uk-icon {
        color: #3782AA;
        margin: 0;
      };
    }
  }

  .criteres-list-wrap .list-group-item {

  }

  .criteres-list-wrap .list-group-item:last-child {

  }

  .criteres-list-wrap .list-group-item .critere-item .uk-icon {
    color: #0186B1;
    margin: 0;
  }

  .criteres-list-wrap .list-group-item .critere-item .uk-link .uk-icon {
    color: #d8d8d8;
  }

  .criteres-list-wrap .list-group-item:first-child {
    border-top-left-radius: .25rem;
    border-top-right-radius: .25rem;
  }

  .criteres-list-wrap .list-group-item.level_2 {
    .critere-item-wrapper{
      background-color: #F6F6F6;
      padding: 3px 10px;
      .critere-item {
        padding: .25rem 0.5rem;
        font-size: 12px;
        font-weight: 400;
      }
    }

  }

  .criteres-list-wrap .critere-item-wrapper.close {
    display: none;
  }

  /* RIGHT LIST */

  .advform{
    padding-top: 15px ;
  }
  .advform .uk-grid{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .form-list-wrap {
    border: 1px solid rgba(0, 0, 0, .125);
    border-left: none;
  }

  .form-list-wrap .list-group ul {
    min-height: 15px;
    border-radius: 3px;
  }

  .form-list-wrap .list-group ul.ti-tags {
    min-height: 28px;
  }

  .form-list-wrap .dragArea.empty span {
    background-color: #F0F1F3;
    opacity: 0.5;
    height: 47px;
    display: block;
    border-radius: 3px;
    border: 1px dashed #bbb;
    min-height: 47px;
  }

  .form-list-wrap .list-group-item {
    font-size: 14px;
    cursor: move;
    position: relative;
    display: block;
    padding: .75rem 0.25rem;
    background-color: #fff;
  }

  /* Afficher toujours la barre de défilement */
  .scrollable {
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch; /* Support pour iOS */
    scrollbar-gutter: stable both-edges; /* Demande de barre de défilement visible même sans défilement */
  }

  .scrollable::-webkit-scrollbar {
    width: 12px; /* Largeur de la barre de défilement */
    background-color: #f1f1f1; /* Couleur d’arrière-plan de la barre */
  }

  .scrollable::-webkit-scrollbar-thumb {
    background-color: #888; /* Couleur du pouce (élément défilant) */
    border-radius: 6px;
  }

  .scrollable::-webkit-scrollbar-thumb:hover {
    background: #555;
  }


</style>
